import { render, staticRenderFns } from "./TrainerCovidObservation.vue?vue&type=template&id=d0bc38be&scoped=true&"
import script from "./TrainerCovidObservation.vue?vue&type=script&lang=js&"
export * from "./TrainerCovidObservation.vue?vue&type=script&lang=js&"
import style0 from "./TrainerCovidObservation.vue?vue&type=style&index=0&id=d0bc38be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0bc38be",
  null
  
)

export default component.exports